import React from 'react'
import { Project } from '../projects'
import './Vignette.css'

const Vignette = ({ project, onClick }: { project: Project, onClick: () => void }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      className="Vignette"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onClick()}
    >
        <div className="Vignette-content" style={{
          backgroundImage: `url(${project.miniatureUrl})`
        }}>
          <img className="Vignette-play" src="/play.png" alt="Play" />
        </div>
        <div className="Vignette-text" style={{opacity: hovered ? 1 : 0}}>
          <h2>{project.title}</h2>
          <p>{project.description}</p>
        </div>
    </div>
  )
}

export default Vignette
